module.exports = __webpack_public_path__ + "images/psp/FeaturedContentImages/cc-related-1.webp";